module.exports = __webpack_public_path__ + "images/emoji/sheep.2e535c50f49e7ece833e.png";